import React, { useState } from 'react';
import Modal from '../../ui/Modal';
import { Button } from '../../ui/PageShell';
import { FormGrid, Field, Input, Select } from '../../ui/Form';
import PhoneInput from '../../ui/PhoneInput';
import useDirtyForm from '../useDirtyForm';

export const OFFICE_ROLE_OPTIONS = [
  { value: 'admin', label: 'مدير' },
  { value: 'register', label: 'موجه' },
];

/** Add or edit an office account (مدير / موجه). Teachers get their
 *  login from the المعلمون page; students and parents from the student. */
export default function OfficeUserModal({ user, api, toast, onSaved, onClose }) {
  const isEdit = !!user;
  const [form, setForm] = useState(() => ({
    name: user?.name || '',
    phone: user?.phone || '',
    role: user?.role || 'register',
  }));
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const dirty = useDirtyForm(form);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    const e = {};
    if (!form.name.trim()) e.name = 'الاسم مطلوب';
    if (!form.phone.trim()) e.phone = 'رقم الهاتف مطلوب';
    setErrors(e);
    if (Object.keys(e).length) return;
    setSaving(true);
    try {
      if (isEdit) await api.updateUser(user.id, form);
      else await api.createUser(form);
      toast.success(isEdit ? 'تم حفظ التعديلات' : 'تمت إضافة المستخدم');
      onSaved();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open
      title={isEdit ? `تعديل ${user.name}` : 'مستخدم جديد'}
      onClose={onClose}
      confirmClose={dirty?.isDirty}
      footer={(requestClose) => (
        <>
          <Button variant="secondary" onClick={requestClose}>إلغاء</Button>
          <Button onClick={save} loading={saving} data-guide="modal-save">{isEdit ? 'حفظ' : 'إضافة'}</Button>
        </>
      )}
    >
      <FormGrid columns={1}>
        <Field label="الاسم الكامل" required error={errors.name} hint="يكتبه المستخدم عند تسجيل الدخول" guide="user-name">
          <Input value={form.name} onChange={set('name')} error={errors.name} autoFocus />
        </Field>
        <Field label="رقم الهاتف" required error={errors.phone} hint="يصله رمز الدخول عليه" guide="user-phone">
          <PhoneInput value={form.phone} onChange={(v) => setForm((f) => ({ ...f, phone: v }))} />
        </Field>
        <Field label="الدور" required guide="user-role">
          <Select value={form.role} onChange={set('role')} options={OFFICE_ROLE_OPTIONS} />
        </Field>
      </FormGrid>
    </Modal>
  );
}
